export const SPARK_ROUTES = {
  MEMORIES: '/sources',
  MEMORY: '/memory',
  LOGIN: '/login',
  SPARK_RUNS: '/spark',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  AUTH_CALLBACK: '/auth/callback',
  RESET_PASSWORD: '/reset-password',
  SPARK_BUILDER: '/spark/builder',
  SPARK_RUN_DETAIL: '/spark/run',
  HISTORY: '/history',
  BOARD: '/boards',
  RESOURCE_SHARES: '/resource-shares/:id',
  DASHBOARD: '/dashboard',
} as const;
